import { js_beautify } from 'js-beautify';

export function IsJson(text: string): boolean {
  if (typeof text !== 'string') {
    return false;
  }

  const isJsonRegex = /^\s*(\{[\s\S]*\}|\[[\s\S]*\])\s*$/;
  return isJsonRegex.test(text.trim());
}

export function TryParseJsonWithErrorDetails(text: string): [boolean, string | null] {
  try {
    JSON.parse(text);
    return [true, null];
  } catch (error) {
    return [false, error.message];
  }
}

export function PrettifyJson(rawJson: string): string {
  return js_beautify(rawJson, { indent_size: 4 });
}

export function MinifyJson(jsonText: string): string {
  return JSON.stringify(JSON.parse(jsonText));
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/json.utils.ts